import React from 'react'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

import SEO from 'components/SEO'
import LayoutProject from 'components/LayoutProject'
import ProjectDetailsText from 'components/projects/shared/ProjectDetailsText'
import ProjectSection from 'components/projects/shared/ProjectSection'

import LiveCards from 'images/projects/live/live-cards.avif'
import LiveSdkLogo from 'images/projects/live/live-sdk-logo.webp'
import LiveHeroOneLeft from 'images/projects/live/live-hero-one-left.avif'
import LiveHeroOneRight from 'images/projects/live/live-hero-one-right.webp'
import LiveHeroThreeLeft from 'images/projects/live/live-hero-three-left.webp'
import LiveHeroThreeRight from 'images/projects/live/live-hero-three-right.webp'
import LiveHeroFourLeft from 'images/projects/live/live-hero-four-left.webp'
import LiveHeroFourRight from 'images/projects/live/live-hero-four-right.webp'

import projectData from 'data/projects/live'
// Next Project
import nextProject from 'data/projects/betql'
import { LIVE, THEME_LIVE_PURPLE, THEME_GREY } from 'theme/constants'

gsap.registerPlugin(ScrollTrigger)

/* eslint-disable react/jsx-no-bind */
const LivePage = () => {
  const { conversionAndSales } = projectData

  return (
    <LayoutProject
      theme={THEME_LIVE_PURPLE}
      projectId={LIVE}
      singleColumnOverview
      projectData={projectData}
      nextProject={nextProject}
    >
      <SEO
        title="Live - Strategy, Design & Web Dev | Build With Studio"
        description="Explore how we brought Live's vision to life. We offer digital product design and development services to businesses of all sizes."
      >
        <link
          rel="canonical"
          href="https://buildwithstudio.com/portfolio/live/"
        />
        <link rel="preload" as="image" href={LiveHeroOneLeft}></link>
        <link rel="preload" as="image" href={LiveHeroOneRight}></link>
        <link rel="preload" as="image" href={LiveHeroThreeLeft}></link>
        <link rel="preload" as="image" href={LiveHeroThreeRight}></link>
        <link rel="preload" as="image" href={LiveHeroFourLeft}></link>
        <link rel="preload" as="image" href={LiveHeroFourRight}></link>
      </SEO>
      <ProjectSection refIndex={6} theme={conversionAndSales.theme}>
        <ProjectDetailsText
          title={conversionAndSales.title}
          paragraphs={conversionAndSales.paragraphs}
        />
      </ProjectSection>
      <ProjectSection refIndex={7} theme={THEME_GREY}>
        <div className="project__section__container live-cards-section">
          <div className="project__content__container --stretch live-middle-section">
            <div className="live-cards-image-container">
              <img
                className="live-cards-image"
                src={LiveCards}
                alt="live cards"
                loading="lazy"
              />
              <img
                className="live-sdk-logo"
                src={LiveSdkLogo}
                alt="live sdk logo"
                loading="lazy"
              />
            </div>
            <ProjectDetailsText
              title="Engage your customers like never before with shoppable video from Live."
              paragraphs={[
                'Easily manage and organize your videos using our proprietary content management system. Customers can watch videos or shop live or after your stream is ended. You can even embed Live into your online store.',
              ]}
            />
          </div>
        </div>
      </ProjectSection>
    </LayoutProject>
  )
}
/* eslint-enable react/jsx-no-bind */

export default LivePage
